import Card from '@mui/material/Card';

const CustomCard = ({children, className, style}) => {
    return (
        <Card className={className} sx={style}>
            {children}
        </Card>
    );
}

CustomCard.defaultProps = {
    children: <></>,
    className: '',
    style: {}
};

export default CustomCard;